export default __webpack_public_path__ + "static/media/bird.6cd17a57.png";